import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import { BetslipUpsellConstants } from '../../../../lib/betslip-base/models/betslip-upsell.model';
import { betslipSelector } from '../../../base/store/selectors';
import { IBetslipRootState, IBetslipState } from '../../../base/store/state';
import BetslipPickUtilsService from '../../picks/services/betslip-pick-utils.service';
import { BetslipTrackingHelper } from '../../tracking/services/betslip-tracking-helper';
import UpsellTrackingActions from './upsell-tracking.actions';

export interface UpsellTrackingData {
    action?: string;
    location: string;
    eventDetails: string;
    modulePosition?: string;
    sportId: string;
    eventds?: string;
}

export enum UpsellTracking {
    Click = 'Click',
    Load = 'Load',
    Collapse = 'Collapse',
    Expand = 'Expand',
    ShowLess = 'ShowLess',
    UpsellModule = 'Upsell Module',
}

@Injectable()
export default class UpsellTrackingEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
        private betslipPickUtils: BetslipPickUtilsService,
        private trackingService: TrackingService,
    ) {}

    handleUpsellTrackingEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(UpsellTrackingActions.track),
                concatLatestFrom(() => this.store.select(betslipSelector)),
                tap(([action, state]) => this.trackBetslipUpsell(action, state)),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    private trackBetslipUpsell(payload: { eventDetails: string; action?: string }, state: IBetslipState): void {
        const picks = this.betslipPickUtils.getSelectedPicks(state.types, state.picks.pickList);
        this.trackingService.track(payload.action === UpsellTracking.Load ? trackingConstants.EVENT_CONTENT_VIEW : trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: BetslipUpsellConstants.TrackingCategoryEvent,
            [trackingConstants.COMPONENT_LABEL_EVENT]: BetslipUpsellConstants.TrackingLabelEvent,
            [trackingConstants.COMPONENT_ACTION_EVENT]: payload.action,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: BetslipTrackingHelper.toUpperFirst(state.types.base.currentSelectedType?.toString() || ''),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: payload.eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.SPORT_ID]: picks[0]?.sportId?.toString() ?? '',
        });
    }
}
